import { render, staticRenderFns } from "./add.vue?vue&type=template&id=c9da8b2c&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=c9da8b2c&prod&lang=scss&scoped=true&"
import style1 from "./add.vue?vue&type=style&index=1&id=c9da8b2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9da8b2c",
  null
  
)

export default component.exports